import { Box, Button, Card, CardContent, CardHeader, Stack, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import {  useState } from "react";
import * as Yup from 'yup';


function CreateGroup(props) {
    // const{contacts, upDate} = useContext(contactContext)

    const { handleSave } = props;


    const myFormik = useFormik({
        initialValues: {
            'groupName': '',
            'deleted': false,
            'label': '',
            edit: 'none',
        },

        validationSchema: Yup.object(
            {
                groupName: Yup.string().required('Required').min(3, 'must be more than 3 characters'),
            }
        ),

        onSubmit: values => {
            console.log(JSON.stringify(values, null, 2));
            handleSave(values);
        },

    })



    return (<>
        <Card elevation={2}>
            <CardHeader title='New Group' />
            <CardContent>
                <form onSubmit={myFormik.handleSubmit}>
                    <Box display='flex' columnGap={2}>
                        <Stack>
                            <TextField
                                size="small"
                                required
                                label='Group Name'
                                id="groupName"
                                name="groupName"
                                value={myFormik.values.groupName}
                                onChange={myFormik.handleChange}
                                onBlur={myFormik.handleBlur} />
                            {myFormik.errors.groupName && myFormik.touched.groupName ? <Typography color="error">{myFormik.errors.groupName}</Typography> : null}
                        </Stack>
                    </Box>
                    <Box display={'flex'}>
                        <Button type="submit" sx={{ ml: 'auto' }}>Create</Button>
                    </Box>
                </form>
            </CardContent>
        </Card>
    </>);
}


export default CreateGroup;